import {
  AnalogueModelDetail,
  AnalogueModelSourceType,
  FileType,
  JobStatus,
} from '../api/generated';

export const analogueModelDefault: AnalogueModelDetail = {
  analogueModelId: '',
  name: '',
  description: '',
  createdBy: '',
  createdDate: undefined,
  lastModifiedBy: '',
  lastModifiedDate: undefined,
  isProcessed: false,
  sourceType: AnalogueModelSourceType.DELTARES,
  fileUploads: [],
  modelAreas: [],
  stratigraphicGroups: [],
  geologicalGroups: [],
  outcrops: [],
  analogueModelImage: {
    analogueModelImageId: '',
    fileName: '',
    type: FileType.JPG,
  },
  iniParameters: {
    archels: [],
  },
  processingStatus: JobStatus.UNKNOWN,
};
